module.exports = __webpack_public_path__ + "static/media/event-services-img45.96e0931b.jpg";